__webpack_require__.p = "https://techminds.pstatic.net/pkgtour/statics/vertical-v2/bc42664da8e709ce76de7488d20267c712159f6e/_next/";